import React, { useEffect, useState } from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate, useParams } from 'react-router-dom';
import WeaveInputs from '../../components/WeaveInputs/WeaveInputs';
import { connect } from 'react-redux';
import { updateWeaveRequestAction } from '../../store/weave/weaveActions';
import { useTranslation } from '../../hooks/useTranslation';
import { getWeaves } from '../../services/endpoints';

const UpdateWeave = ({ updateWeaveRequest, isLoading, updateWeaveData }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const [weaveData, setWeaveData] = useState(null);
  const [loadingWeave, setLoadingWeave] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const loadWeave = async () => {
      setLoadingWeave(true);
      try {
        const { data } = await getWeaves({ WeaveId: id });
        if (!isMounted) return;
        setWeaveData(data?.WeaveList?.[0] || null);
      } catch (error) {
        console.error('Error loading weave for update:', error);
        if (isMounted) setWeaveData(null);
      } finally {
        if (isMounted) setLoadingWeave(false);
      }
    };

    if (id) {
      loadWeave();
    } else {
      setLoadingWeave(false);
      setWeaveData(null);
    }

    return () => {
      isMounted = false;
    };
  }, [id]);

  const handleSubmit = (data) => {
    updateWeaveRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/weave');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/weave" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('weave')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateWeave')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('updateWeave')}</h4>
            </CCardHeader>
            <CCardBody>
              {loadingWeave ? (
                <div className="text-center py-4">
                  <p>{t('loading') || 'Yukleniyor...'}</p>
                </div>
              ) : weaveData ? (
                <WeaveInputs
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  isLoading={isLoading}
                  submitResponse={updateWeaveData}
                  initialData={weaveData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center py-4">
                  <p>{t('noDataFound')}</p>
                  <button className="btn btn-primary mt-3" onClick={handleCancel}>
                    Back to Weave List
                  </button>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  updateWeaveData: state.weaveReducer.updateWeaveData,
});

const mapDispatchToProps = (dispatch) => ({
  updateWeaveRequest: (payload) => dispatch(updateWeaveRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateWeave);
